import { useTranslation } from 'next-i18next'

// Components
import PortraitReleaseAgreementPopupContentForm from './PortraitReleaseAgreementPopupContentForm'
import PortraitReleaseAgreementPopupContentFormik from './PortraitReleaseAgreementPopupContentFormik'

const PortraitReleaseAgreementPopupContent = (props: any) => {
  const { t } = useTranslation()

  return (
    <PortraitReleaseAgreementPopupContentFormik {...props} t={t}>
      <PortraitReleaseAgreementPopupContentForm {...props} />
    </PortraitReleaseAgreementPopupContentFormik>
  )
}

export default PortraitReleaseAgreementPopupContent
